import {TeaInfoType} from '@/types/tea'

const useDefaultState = {
	tea: {
		class: [],
		school: {
			id: 0,
			school_name: '',
			province_id: 0,
			city_id: 0,
			borough_id: 0,
			study_section: 0,
			area: '',
			edu_system: 0,
			subject: '',
			limit_tea: 0,
			limit_stu: 0,
			name_type: 0
		},
		study_section: 0,
		address: '',
		uid: '',
		teacher_name: '',
		phone: '',
		is_grade_teacher: 0,
		user_type: 5, // 5: 管理员，6: 老师
		school_id: 0,
		borough_id: 0,
		school_info: {}
	} as TeaInfoType
}

export type UseDefaultStateType = typeof useDefaultState

export default useDefaultState
